export const icon = () => {
    return (
        <img src={innovatorAi.images.logoSm} width={24} />
    );
}